export const OFFICIAL_PARTNERS = [
  {
    id: 'leva',
    name: 'Leva Consultation & Services',
    logo: 'https://customer-assets-agu9un31.emergentagent.net/job_hope-rebuild-2/artifacts/bct2qwfy_IMG_0632.webp',
    website: 'https://levaconsultation.com',
  },
];
